import { render } from "./ViewAllBuildings.vue?vue&type=template&id=d65040c0"
import script from "./ViewAllBuildings.vue?vue&type=script&lang=js"
export * from "./ViewAllBuildings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__